const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'YOUR_CLOUD_NAME';

/**
 * Returns an optimized image URL via Cloudinary.
 * Works with both Cloudinary URLs and external URLs (e.g. fal.ai).
 *
 * Usage:
 *   getOptimizedImage(item.imageUrl, 200)   // 200px wide thumbnail
 *   getOptimizedImage(item.imageUrl, 600)   // 600px wide for carousel
 */
export const getOptimizedImage = (
  url: string,
  width: number = 400,
  options: { height?: number; quality?: string; format?: string } = {}
): string => {
  if (!url) return '';

  const { height, quality = 'auto', format = 'auto' } = options;

  const transforms = [
    `w_${width}`,
    height ? `h_${height}` : null,
    'c_fill',
    `q_${quality}`,
    `f_${format}`,
  ]
    .filter(Boolean)
    .join(',');

  // Cloudinary upload URL — inject transforms after /upload/
  if (url.includes('res.cloudinary.com') && url.includes('/upload/')) {
    return url.replace('/upload/', `/upload/${transforms}/`);
  }

  // External URL (e.g. fal.ai) — use Cloudinary fetch mode
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/fetch/${transforms}/${encodeURIComponent(url)}`;
};